import * as types from "../constants/actions-type";

const setSectionsLoaded = () => ({
  type: types.SET_SECTIONS_LOADED,
});

export default setSectionsLoaded;
